import React, { useRef } from 'react';
import { v4 as uuid } from 'uuid';
import classNames from 'classnames';
import { useButton } from '@react-aria/button';
import { useFocusRing } from '@react-aria/focus';
import { Icon, LoadingSpinner, Tooltip } from 'Permafrost/index';
import { StyledControlButton, iconSizeDefault } from './ControlButton.styles';
export const controlButtonSpacing = {
    normal: '16px',
};
const controlButton = {
    reject: { icon: 'trash', label: 'Reject' },
    submit: { icon: 'check', label: 'Submit' },
    restore: { icon: 'upload', label: 'Restore' },
    'step-forward': { icon: 'step-forward', label: 'Step Forward' },
};
/**
 * Small icon-only buttons used for UI controls.
 */
export function ControlButton(props) {
    const { busy, buttonType, className, id, tooltipDisabled, tooltipText } = props;
    const buttonEl = useRef();
    const { buttonProps } = useButton(props, buttonEl);
    const { isFocusVisible, focusProps } = useFocusRing();
    const iconSize = buttonType === 'submit' ? '22px' : iconSizeDefault;
    const tooltipId = uuid();
    const buttonTooltipProps = tooltipDisabled
        ? {
            'aria-label': controlButton[buttonType].label,
        }
        : { 'data-tip': true, 'data-for': tooltipId, 'aria-labelledby': tooltipId };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledControlButton, Object.assign({ "$buttonType": buttonType, "$iconSize": iconSize, id: id, className: classNames(className, {
                'focus-visible': isFocusVisible,
            }), "data-cy": props['data-cy'] }, buttonProps, focusProps, buttonTooltipProps), busy ? (React.createElement(LoadingSpinner, { size: iconSizeDefault })) : (React.createElement(Icon, { name: controlButton[buttonType].icon, size: [iconSize] }))),
        !tooltipDisabled && (React.createElement(Tooltip, { for: tooltipId }, tooltipText || controlButton[buttonType].label))));
}
//# sourceMappingURL=ControlButton.js.map